
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';

// SVG
import ArrowBackSVG from '@/assets/arrow_back.svg';
import AttachSVG from '@/assets/attach.svg';

// Components
import VButtonIcon from '@/components/VButton/VButtonIcon.vue';

// Utils
import { debounce, get, last } from 'lodash';

@Component({
    inheritAttrs: false,
    components: { ArrowBackSVG, VButtonIcon, AttachSVG },
})
export default class VTextarea extends Vue {
    @Ref() public textBlock!: HTMLElement;

    @VModel({ type: String, default: '' })
    public input!: string | null;

    @Prop({ type: Boolean, default: false })
    public selfSend!: boolean;

    @Prop({ type: Boolean, default: false })
    public attach!: boolean;

    @Prop({ type: Number, default: 0 })
    public attachCount!: number;

    @Prop({ type: Number })
    public max!: number;

    @Prop({ type: String, default: '' })
    public placeholder!: string;

    @Prop({ type: Boolean, default: false })
    public error!: boolean;

    @Prop({ type: Boolean, default: false })
    public autofocus!: boolean;

    @Prop({ type: Boolean, default: false })
    public disabled!: boolean;

    textLength = 0;
    public updateValue = debounce((value: string) => this.$emit('input', value), 250);

    get contentEditable() {
        return this.disabled ? 'false' : 'plaintext-only';
    }

    public onInput(event: InputEvent) {
        let value = (event.target as HTMLElement).innerText;

        if (this.max && value.length > this.max) {
            value = this.textBlock.innerText = value.substring(0, this.max);
            this.setSelection();
        }

        this.textLength = value.trim().length;
        this.updateValue(value);
    }

    public setSelection() {
        const range = document.createRange();
        const sel = window.getSelection();

        const lastLine = last(this.textBlock.childNodes)!;
        const length: number = get(lastLine, 'length');
        range.setStart(lastLine, length);
        range.collapse(true);

        sel?.removeAllRanges();
        sel?.addRange(range);
    }

    public send() {
        const trimmed = this.input?.trim();
        if (trimmed?.length) this.$emit('send', trimmed);
    }

    public handleKeyUp(event: KeyboardEvent) {
        // allow to send message on Ctrl + Enter keyup combination
        if (event.ctrlKey) this.send();
    }

    public focusTextBlock() {
        this.textBlock.focus();
    }

    @Watch('input')
    inputChangeHandler(newValue: string, oldValue: string) {
        if (newValue === oldValue || newValue === this.textBlock.innerText) return;
        this.textBlock.innerText = newValue;
        this.textLength = this.textBlock.innerText.trim().length;
    }

    mounted() {
        this.textBlock.innerText = this.input ?? '';
        this.textLength = this.textBlock.innerText.trim().length;

        if (this.autofocus) {
            this.textBlock.focus();
        }
    }
}
